// ABOUTME: Padlock/lock icon component for locked areas
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const LockIcon = ({ className = "", size = 12, color = "#9CA3AF" }: IconProps) => (
  <svg
    width={size}
    height={size * 1.0833}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.375 4.375H8.625V3.0625C8.625 2.36631 8.34844 1.69863 7.85616 1.20634C7.36387 0.714062 6.69619 0.4375 6 0.4375C5.30381 0.4375 4.63613 0.714062 4.14384 1.20634C3.65156 1.69863 3.375 2.36631 3.375 3.0625V4.375H1.625C1.39294 4.375 1.17038 4.46719 1.00628 4.63128C0.842187 4.79538 0.75 5.01794 0.75 5.25V11.375C0.75 11.6071 0.842187 11.8296 1.00628 11.9937C1.17038 12.1578 1.39294 12.25 1.625 12.25H10.375C10.6071 12.25 10.8296 12.1578 10.9937 11.9937C11.1578 11.8296 11.25 11.6071 11.25 11.375V5.25C11.25 5.01794 11.1578 4.79538 10.9937 4.63128C10.8296 4.46719 10.6071 4.375 10.375 4.375ZM4.25 3.0625C4.25 2.59837 4.43437 2.15325 4.76256 1.82506C5.09075 1.49687 5.53587 1.3125 6 1.3125C6.46413 1.3125 6.90925 1.49687 7.23744 1.82506C7.56563 2.15325 7.75 2.59837 7.75 3.0625V4.375H4.25V3.0625ZM10.375 11.375H1.625V5.25H10.375V11.375Z"
      fill={color}
    />
  </svg>
)
